import React from "react";
import { Image } from "react-bootstrap";
import card_front from "../../assets/images/id_front.png";
import { Spinner } from "react-bootstrap";

export default ({
  uploadfileManually,
  isActive,
  imageUrl,
  loader,
  iscompletedForm,
  validationError,
  validationerror,
}) => {
  return (
    <div 
      className={`id_upload_box ${loader ? "loader-div-show" : ""}`}
      style={{
        borderColor: !imageUrl
          ? validationError?.data || validationerror
            ? "#fa4a4a"
            : ""
          : "",
      }}
    >
      <div
        className="id_upload_box_inner"
        style={{
          backgroundColor: !imageUrl
            ? validationError?.data || validationerror
              ? "#fff1f1"
              : ""
            : "",
        }}
      >
        {loader ? (
          <Spinner animation="grow" />
        ) : imageUrl ? (
          <div className="image-upload-div">
            <Image
              src={imageUrl}
              alt="imageUrl"
              style={{ width: "100%", height: "100%" }}
            />
            <span>
              {!iscompletedForm ? (
                <input
                  type="file"
                  style={{ cursor: "pointer" }}
                  onChange={uploadfileManually}
                ></input>
              ) : (
                ""
              )}
            </span>
          </div>
        ) : (
          <div className="button_wrap">
            <div
              className="id_upload_btn"
              style={{
                backgroundColor: !imageUrl
                  ? validationError?.data || validationerror
                    ? "#fa4a4a"
                    : ""
                  : "",
              }}
            >
              <img src={card_front} alt="card_front" />
              <p
                className="id_type"
                style={{
                  color: !imageUrl
                    ? validationError?.data || validationerror
                      ? "#fff1f1"
                      : ""
                    : "",
                }}
              >
                Add front Of ID
              </p>
              <p
                className="type"
                style={{
                  color: !imageUrl
                    ? validationError?.data || validationerror
                      ? "#fff1f1"
                      : ""
                    : "",
                }}
              >
                JPEG or PNG
              </p>
              <p
                className="type"
                style={{
                  color: !imageUrl
                    ? validationError?.data || validationerror
                      ? "#fa4a4a"
                      : ""
                    : "",
                  fontSize: "13px",
                }}
              >
                {isActive ? "Release to drop" : "Or Drag them in"}
              </p>
              {!iscompletedForm ? (
                <input
                  type="file"
                  style={{ cursor: "pointer" }}
                  onChange={uploadfileManually}
                ></input>
              ) : (
                ""
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
